import axios from "axios";

export default {
  beforeCreate(context, inject) {
    const { store, req } = context;

    const httpClient = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      timeout: 50000
    });

    httpClient.interceptors.request.use(async config => {
      let token = null;

      // Block all requests until splash call finishes
      if (process.client && store.state.is_splash_call_pending) {
        await new Promise(resolve => {
          const unwatch = store.watch(
            state => state.is_splash_call_pending,
            is_splash_call_pending => {
              if (!is_splash_call_pending) {
                unwatch();
                resolve();
              }
            }
          );
        });
      }

      if (process.server) {
        // "ssr" is a special token to allow data fetching on the server.
        token = req.cookies.token || "ssr";
      } else {
        token = require("js-cookie").get("token");
      }

      if (config.method === "get") {
        config.params = config.params || {};
        config.params["access_token"] = token;
      } else if (config.method === "post") {
        if (
          config.data instanceof FormData ||
          config.data instanceof URLSearchParams
        )
          config.data.append("access_token", token);
      }

      if (process.client) store.dispatch("startLoader");

      return config;
    });

    httpClient.interceptors.response.use(
      response => {
        if (process.server && process.env.NODE_ENV !== "production")
          console.debug(
            response.config.method.toUpperCase(),
            response.status,
            response.statusText,
            response.request.path
          );

        if (process.client) store.dispatch("stopLoader");

        return response;
      },
      err => {
        if (process.client) store.dispatch("stopLoader");

        return Promise.reject(err);
      }
    );

    inject("axios", httpClient);
  }
};
